
export default {
  data() {
    return {
      title: "About Us | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "aboutus",
          name: "aboutus",
          content:
            "Bikeflights is an easy-to-use bicycle shipping service and a supplier of easy-to-pack bike shipping boxes. You get low costs, excellent service and on-time delivery with every shipment as part of our Best Way Guarantee.",
        },
      ],
    };
  },
};
